import { default as moment } from 'moment';

import 'moment/locale/tr';

moment.locale('tr');

export const yelkovan = moment;
